import { Typography } from '@mui/material';
import { useResponsive } from 'src/hooks/useResponsive';
type Props = {
  label: { value: number; name: string };
  topPosition: string;
};

export const Label = ({ label, topPosition }: Props) => {
  const isMobile = useResponsive('down', 600);

  return (
    <Typography
      sx={{
        position: 'absolute',
        left: -80,
        transform: 'translateY(-50%)',
        fontSize: isMobile ? '9px' : '12px',
        whiteSpace: 'nowrap',
        textAlign: 'right',
        right: '100%',
        pr: 1,
        top: topPosition,
      }}
    >
      {label.name} -
    </Typography>
  );
};
